<template>
	<v-container grid-list-xl>		
		<v-form v-model="isAddValid">
			<v-layout row wrap>				
				<v-flex lg12>
					<label class="blackLabel">* Name:</label>
					<v-text-field label="Factory Name" :rules="nameRules" solo v-model="factoryName" single-line required></v-text-field>
				</v-flex>				
                <v-flex lg12>
                  <label class="blackLabel">* Description:</label>
                  <v-text-field label="Factory Description" :rules="descriptionRules" solo v-model="factoryDescription" single-line required></v-text-field>
                </v-flex>	
                <v-flex lg12>
                  <label class="blackLabel">* Address:</label>
                  <v-text-field label="Address" :rules="addressRules" solo v-model="factoryAddress" single-line required></v-text-field>
                </v-flex>	
				<div class="pl-4 pr-1 pb-2 pt-2 buttonHolder">
					<div style="float: right">
						<v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
						<v-progress-circular indeterminate :width="3" :size="20" v-if="runAdd" color="grey" class="pt-3 loginLoader"></v-progress-circular>
						<v-btn color="success" class="text-xs-right" v-if="!runAdd" :disabled="!isAddValid" @click.stop="fncAddFactory()">Save</v-btn>
                        <small>* The button will activate once all required fields have been completed</small>
					</div>					
				</div>							
			</v-layout>
		</v-form>	
	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex'; 	
	import Swatches from 'vue-swatches';
	import "vue-swatches/dist/vue-swatches.min.css";
	
	export default {
	  name: 'Settings',
	  components: { Swatches },
	  data () {
			return {
				runAdd: false,
				isAddValid: false,
                factoryName: '',
                factoryDescription: '',
                factoryAddress: '',
				nameRules: [
					v => !!v || 'Factory name is required',				
				],
				descriptionRules: [
					v => !!v || 'Factory description is required',				
				],
				addressRules: [
					v => !!v || 'Factory address is required',				
				]				
			};
		},		
		methods: {
			fncHideModal () {
				this.$store.commit('hideModal');
			},
            fncAddFactory() {		
				this.runAdd = true;	
				this.$store.dispatch({
                  type: 'fncAddFactory',
                  name: this.factoryName,
                  description: this.factoryDescription,
                  address: this.factoryAddress										
				});			
			}
		},
		computed: {
			...mapGetters([			
				'objAuthorize',				
				'globalModalParams'
			])
		}
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>